import { atom, type RecoilState } from 'recoil';
import type { DicomTransfer, DicomTransferJob } from './types';

/*
 * Deliberately not persisted and not broadcast across tabs: these hold patient name, MRN and
 * accession, and R-31 forbids exposing PHI outside the session. Sibling worklist atoms do persist
 * by convention, so the omission is intentional.
 */

export const dicomTransfersState: RecoilState<readonly DicomTransfer[]> = atom<
  readonly DicomTransfer[]
>({
  key: 'dicomSendTransfers',
  default: [],
});

export const dicomTransferJobsState: RecoilState<Readonly<Record<string, DicomTransferJob>>> = atom<
  Readonly<Record<string, DicomTransferJob>>
>({
  key: 'dicomSendTransferJobs',
  default: {},
});
